// extracted by mini-css-extract-plugin
export default {"button":"MarketingPromoButton__button--3YKSY","hideIcon":"MarketingPromoButton__hideIcon--36YLi"};